import ManualSorting from '@features/ManualSorting/ui/ManualSorting';

export default function SortingTapeBagsPage() {
    return <ManualSorting isSortingTapeBags />
}